module.exports = __webpack_public_path__ + "static/desktop/img/diarybook-3.966dfa0d.png";